module.exports = __webpack_public_path__ + "img/ico_btn_like_bk.981cb01.svg";